var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 13.1875C19.625 17.625 16.5938 20.75 12.125 20.75C7.8125 20.75 4.375 17.3125 4.375 13C4.375 8.71875 7.8125 5.25 12.125 5.25C14.1875 5.25 15.9688 6.03125 17.3125 7.28125L15.1875 9.3125C12.4375 6.65625 7.3125 8.65625 7.3125 13C7.3125 15.7188 9.46875 17.9062 12.125 17.9062C15.1875 17.9062 16.3438 15.7188 16.5 14.5625H12.125V11.9062H19.5C19.5625 12.3125 19.625 12.6875 19.625 13.1875Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.fa10b1ee3622c73e20f8ed6d378cfe36.svg";
export { ForwardRef as ReactComponent };